<template>
    <b-card
        :title="title"
        :loading="loading"
        :cardLoading="loading"
        :error-message="errorMessage"
        @cancel="$emit('cancel')"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
        @submit="
            () => {
                mode === 'default'
                    ? updateDefaultPermissions()
                    : updateStorePermissions(storeId);
            }
        "
    >
        <v-row no-gutters
            >
            <b-object-treeview class="pa-5" v-model="permissions" :loading="loading"/>
        </v-row>
    </b-card>
</template>

<script>
import {
    mdiMenuRight,
    mdiMenuDown,
    mdiCheckboxBlankOutline,
    mdiCheckBoxOutline
} from "@mdi/js";

import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/userRights";
import { cloneDeep } from "lodash";

export default {
    name: "RightsForm",

    props: {
        mode: String,
        storeId: Number
    },

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiMenuRight,
                mdiMenuDown,
                mdiCheckboxBlankOutline,
                mdiCheckBoxOutline
            },
            showPassword: false,
            allPermissions: false
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "resetSuccess",
            "resetValidation"
        ]),
        ...mapState("loyaltyPanel/stores/storesTab", [
            "storesDefaultPermissions"
        ]),

        ...mapState("loyaltyPanel", [
            "company",
        ]),
        lang() {
            return this.$route.params.lang;
        },

        permissions: {
            get() {
                return this.$store.state.loyaltyPanel.stores.storesTab
                    .permissions;
            },
            set(val) {
                this.setPermissions(val);
            }
        },

        title() {
            return this.mode === "default"
                ? this.translations.rights[this.lang]
                : this.translations.rights[this.lang];
        }
    },

    methods: {
        ...mapMutations(["setResetSuccess", "setResetValidation"]),
        ...mapMutations("loyaltyPanel/stores/storesTab", ["setPermissions"]),
        ...mapActions("loyaltyPanel/stores/storesTab", [
            "updateDefaultPermissions",
            "updateStorePermissions"
        ])
    },
    mounted() {
        if (this.mode == "default") {
            this.permissions = cloneDeep(this.company.default_store_permissions);
        }
    },

    watch: {
        mode(val) {
            if (val === "default") {
                this.permissions = cloneDeep(this.company.default_store_permissions);
            }
        }
    }
};
</script>
